// Helper to convert asset profile name to ID
// Converts "Airport" -> "airport", removes all non-alphanumeric characters
export const convertAssetProfileNameToId = (name: string): string =>
  name.toLowerCase().replace(/[^a-z0-9]/g, '');

// Helper to convert asset profile name to protobuf-style ID
// Converts "ASSET_PROFILE_CASINO" -> "casino"
export const convertToAssetProfileId = (name: string): string => {
  // Remove ASSET_PROFILE_ prefix if present
  const cleanedName = name.replace(/^ASSET_PROFILE_/i, '');

  // Convert to lowercase and remove all non-alphabetic characters
  return convertAssetProfileNameToId(cleanedName);
};

// Helper to convert enumStore name to protobuf enum format
// Converts "Airport" -> "ASSET_PROFILE_AIRPORT"
// Converts "Special Event" -> "ASSET_PROFILE_SPECIAL_EVENT"
export const convertToAssetProfileEnum = (name: string): string => {
  // Convert to uppercase and replace spaces/special chars with underscores
  const enumName = name
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_|_$/g, ''); // Remove leading/trailing underscores

  return `ASSET_PROFILE_${enumName}`;
};

// Helper to create options for Site Survey (converts enumStore to protobuf format)
// Input: [{id: "0", name: "Unknown"}, {id: "airport", name: "Airport"}]
// Output: [{value: "UNKNOWN_ASSET_PROFILE", label: ""}, {value: "ASSET_PROFILE_AIRPORT", label: "Airport"}]
export const createAssetProfileOptions = (
  assetProfiles: { id: string; name: string }[],
): { label: string; value: string }[] =>
  assetProfiles
    .filter((profile) => profile.id)
    .map((profile) => ({
      value: profile.id === '0' ? 'UNKNOWN_ASSET_PROFILE' : convertToAssetProfileEnum(profile.name),
      label: profile.id === '0' ? ' ' : profile.name,
    }));
